import checkActiveOptionType from "@CheckOrder/features/addons/features/jadrolinija/functions/checkActiveOptionType";
import {useEffect} from "react";
import {SetStateType} from "@/types/generic/SetState.type";
import {
    JadrolinijaVehicleModelType
} from "@CheckOrder/features/addons/features/jadrolinija/types/JadrolinijaVehicleModel.type";
import {DimensionOption, VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonData.type";

interface UseResetDataOnVehicleTypeUpdateAttr {
    setRegistrationNumber: SetStateType<string>,
    setHeight: SetStateType<DimensionOption | null>,
    setLength: SetStateType<DimensionOption | null>,
    setVehicle: SetStateType<JadrolinijaVehicleModelType>,
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType },
}

/**
 * On vehicle type update reset all the selected fields
 */
export default function useResetDataOnVehicleTypeUpdate(attr: UseResetDataOnVehicleTypeUpdateAttr) {
    const {
        setRegistrationNumber,
        setHeight,
        setLength,
        setVehicle,
        activeOption,
    } = attr

    const {isCar, isMotorcycle, isBike} = checkActiveOptionType()

    useEffect(() => {
        setRegistrationNumber("")
        setHeight(null)
        setLength(isMotorcycle(activeOption) ? activeOption.activeGroup.lengthOptions[0] : null)
        setVehicle(undefined)
    }, [isCar(activeOption), isMotorcycle(activeOption), isBike(activeOption)]);
}